function StatCard({ statName, statValue, hasPrice, color }) {
    return (
        <div className='border border-[#EAEAEA] p-6 max-[1280px]:p-4 max-[1024px]:px-3 flex flex-col gap-1 max-[1152px]:gap-2 rounded-lg'>
            <h2 className='font-urbanist-regular font-semibold text-[14px] max-[1152px]:text-sm leading-[22px] text-[#666666]'>{statName}</h2>

            <div className="flex items-baseline justify-between">
                <div className="font-urbanist-regular font-semibold">
                    <h2 className={`text-[18px] leading-8 text-[#121212] ${color} ${color?.length && 'uppercase'}`}>
                        {hasPrice && '₹'}
                        {statValue}
                    </h2>
                </div>
            </div>
        </div>
    );
}

export default StatCard;
